import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onCloseStyleSwitcherEvent,
  onOpenStyleSwitcherEvent,
  onSelectStyleSwitcherEvent,
  removeCloseStyleSwitcherEvent,
  removeOpenStyleSwitcherEvent,
  removeSelectStyleSwitcherEvent,
} from '@shared/event/events/style-switcher'

const initStyleSwitcherEvents = (Analytics: GooglePlugin) => {
  const openStyleSwitcherToken = onOpenStyleSwitcherEvent(() => {
    Analytics.event({
      event: 'pdv_style_switcher',
      pdv_action: 'open',
    })
  })

  const closeStyleSwitcherToken = onCloseStyleSwitcherEvent(() => {
    Analytics.event({
      event: 'pdv_style_switcher',
      pdv_action: 'close',
    })
  })

  const selectStyleSwitcherToken = onSelectStyleSwitcherEvent(() => {
    Analytics.event({
      event: 'pdv_style_switcher',
      pdv_action: 'select',
    })
  })

  return () => {
    removeOpenStyleSwitcherEvent(openStyleSwitcherToken)
    removeCloseStyleSwitcherEvent(closeStyleSwitcherToken)
    removeSelectStyleSwitcherEvent(selectStyleSwitcherToken)
  }
}

export default initStyleSwitcherEvents
